import { convertToCamelCaseFromUnderScore } from "../../../../common-utilities/utils";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getShipToLabel, STATUS_CHIP_PROPS } from "./helper";

const formatDate = (val) =>
  val ? new Date(val).toLocaleDateString("en-IN") : null;

const WRAP_TEXT_CELL_FORMAT = "@";
const WRAP_TEXT_NUM_FMT_ID = "49";
const WRAP_TEXT_LINE_HEIGHT = 15;

const setWrapTextColumn = (ws, columnIndex, width = 40) => {
  if (columnIndex < 0 || !ws["!ref"]) return;
  const range = XLSX.utils.decode_range(ws["!ref"]);
  const rows = ws["!rows"] || [];
  for (let r = range.s.r + 1; r <= range.e.r; r += 1) {
    const cell = ws[XLSX.utils.encode_cell({ r, c: columnIndex })];
    if (cell && cell.t === "s") {
      cell.z = WRAP_TEXT_CELL_FORMAT;
      const lineCount = `${cell.v}`
        .split("\n")
        .reduce(
          (sum, line) => sum + Math.max(1, Math.ceil(line.length / width)),
          0
        );
      if (lineCount > 1) rows[r] = { hpt: lineCount * WRAP_TEXT_LINE_HEIGHT };
    }
  }
  ws["!rows"] = rows;
  const cols = ws["!cols"] || [];
  cols[columnIndex] = { wch: width };
  ws["!cols"] = cols;
};

const applyWrapTextStyle = (xlsxBinary) => {
  const cfb = XLSX.CFB.read(xlsxBinary, { type: "binary" });
  const stylesFile = XLSX.CFB.find(cfb, "/xl/styles.xml");
  if (!stylesFile) return XLSX.CFB.write(cfb, { fileType: "zip", type: "array" });
  const xml = new TextDecoder().decode(Uint8Array.from(stylesFile.content));
  const patched = xml.replace(
    new RegExp(`<xf numFmtId="${WRAP_TEXT_NUM_FMT_ID}"([^>]*?)/>`, "g"),
    `<xf numFmtId="${WRAP_TEXT_NUM_FMT_ID}"$1 applyAlignment="1"><alignment wrapText="1"/></xf>`
  );
  const bytes = new TextEncoder().encode(patched);
  stylesFile.content = bytes;
  stylesFile.size = bytes.length;
  return XLSX.CFB.write(cfb, { fileType: "zip", type: "array" });
};

export const downloadReports = (data, storeList = []) => {
  if (!data?.length) {
    return;
  }
  const results = data?.map?.((item) => {
    return {
      "PR Number": item?.prNumber || null,
      "PR Date": formatDate(item?.prDate),
      "Financial Year": item?.financialYear || null,
      "PR Scope": convertToCamelCaseFromUnderScore(item?.prScope),
      "PR Type": item?.prType || null,
      Store: item?.siteName
        ? `${item?.siteCode ? item.siteCode + " - " : ""}${item.siteName}`
        : null,
      "Ship to": getShipToLabel(item, storeList),
      "Preferred Vendor": item?.preferredVendorName || null,
      "Base Est. Amt":
        item?.totalEstimatedAmount != undefined
          ? item?.totalEstimatedAmount
          : null,
      "GST Est. Amt":
        item?.totalEstimatedTaxAmount != undefined
          ? item?.totalEstimatedTaxAmount
          : null,
      "PR Total Est. Amount":
        item?.totalEstimatedGrossAmount != undefined
          ? item?.totalEstimatedGrossAmount
          : null,
      "Balance Est. Amount":
        item?.balanceEstimatedAmount != undefined
          ? item?.balanceEstimatedAmount
          : null,
      "PR Status": STATUS_CHIP_PROPS[item?.status]?.label || item?.status || null,
      "Created By": item?.creatorName || null,
      "Created At": formatDate(item?.createdAt),
    };
  });

  const ws = XLSX.utils.json_to_sheet(results);
  setWrapTextColumn(ws, Object.keys(results[0]).indexOf("Ship to"));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "data");
  const binary = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
  saveAs(
    new Blob([applyWrapTextStyle(binary)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    }),
    "file_pr_report.xlsx"
  );
};
